<nz-select
  class="w-[128px]"
  [nzDropdownMatchSelectWidth]="true"
  [ngModel]="lookbackDays"
  (ngModelChange)="lookbackDaysChange.emit($event)"
>
  @for (option of options; track option.days) {
    <nz-option [nzValue]="option.days" [nzLabel]="option.label"></nz-option>
  }
</nz-select>
